import {createStore} from 'redux';
import {combinedreducer} from './reducers/combinedreducer';
const store = createStore(combinedreducer);

export default store;